import { render, staticRenderFns } from "./Imp.vue?vue&type=template&id=63c3736b&scoped=true&"
import script from "./Imp.vue?vue&type=script&lang=js&"
export * from "./Imp.vue?vue&type=script&lang=js&"
import style0 from "./Imp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Imp.vue?vue&type=style&index=1&id=63c3736b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3736b",
  null
  
)

export default component.exports